import { useState, type ReactNode } from 'react';

type Props = {
  items: ReactNode[];
  threshold?: number;
  initialVisible?: number;
  toggleClassName: string;
  wrapperClassName?: string;
};

export default function ExpandableChipRow({
  items,
  threshold = 20,
  initialVisible = 10,
  toggleClassName,
  wrapperClassName,
}: Props) {
  const [expanded, setExpanded] = useState(false);
  const total = items.length;
  const collapse = total > threshold && !expanded;
  const visible = collapse ? items.slice(0, initialVisible) : items;
  const hiddenCount = total - initialVisible;

  return (
    <span className={wrapperClassName}>
      {visible}
      {total > threshold && (
        <button
          type="button"
          className={toggleClassName}
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
        >
          {expanded ? 'Show less' : `+${hiddenCount} more`}
        </button>
      )}
    </span>
  );
}
